import 'pageflow-scrolled/frontend/index.css';
import 'pageflow-scrolled/contentElements-frontend.css';

import 'pageflow-scrolled/frontend';
import 'pageflow-scrolled/contentElements-frontend';

require.context('../pageflow-scrolled/themes', true);
import './pageflow-scrolled/widgets/almanacRibbon';
